import React from 'react';
import { motion } from 'framer-motion';

/**
 * Composant de séparateur simple et élégant entre les sections
 * Style minimaliste avec des éléments géométriques
 */
const SectionDivider = ({ 
  variant = 'dots', 
  className = '',
  color = 'teal'
}) => {
  const colorClasses = {
    teal: 'text-teal-500 dark:text-teal-500', // Force teal-500 même en dark mode
    amber: 'text-amber-500 dark:text-amber-500', // Force amber-500 même en dark mode
    gray: 'text-gray-300 dark:text-gray-300' // Force gray-300 même en dark mode
  };

  const currentColor = colorClasses[color] || colorClasses.teal;

  if (variant === 'dots') {
    return (
      <div className={`flex justify-center items-center py-8 ${className}`}>
        <div className="flex items-center space-x-2">
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0 }}
            viewport={{ once: true }}
            className={`w-2 h-2 rounded-full ${currentColor} bg-current`}
          />
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className={`w-3 h-3 rounded-full ${currentColor} bg-current`}
          />
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className={`w-2 h-2 rounded-full ${currentColor} bg-current`}
          />
        </div>
      </div>
    );
  }

  if (variant === 'line') {
    return (
      <div className={`flex justify-center items-center py-6 ${className}`}>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
          className={`w-24 h-0.5 ${currentColor} bg-current`}
        />
      </div>
    );
  }

  if (variant === 'diamond') {
    return (
      <div className={`flex justify-center items-center py-8 ${className}`}>
        <motion.div
          initial={{ rotate: 0, scale: 0 }}
          whileInView={{ rotate: 45, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className={`w-3 h-3 ${currentColor} bg-current`}
        />
      </div>
    );
  }

  if (variant === 'spacer') {
    return (
      <div className={`w-full ${className}`}>
        <div className="h-px bg-transparent" />
      </div>
    );
  }

  // Variante par défaut : dots
  return (
    <div className={`flex justify-center items-center py-8 ${className}`}>
      <div className="flex items-center space-x-2">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0 }}
          viewport={{ once: true }}
          className={`w-2 h-2 rounded-full ${currentColor} bg-current`}
        />
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
          className={`w-3 h-3 rounded-full ${currentColor} bg-current`}
        />
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
          className={`w-2 h-2 rounded-full ${currentColor} bg-current`}
        />
      </div>
    </div>
  );
};

export default SectionDivider;
